import { YTDRollUp } from './YTDRollUp';

export class ChannelRollUp extends YTDRollUp {
    public channel: string;
    public countries: { [country: string]: YTDRollUp };
}
